import { z } from 'zod';
const versionedIdentifier = z.string().min(5).max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const tasksAssistantContextCapability = 'tasks.assistant-context.v1';
export const tasksAssistantContextProviderId = tasksAssistantContextCapability;
export const tasksAssistantContextSlot = 'platform.server.optional-context';
export const tasksAssistantContextRequestSchema = z.strictObject({
    requestId: z.string().uuid(),
    subjectType: z.enum(['tasks.task', 'projects.project']),
    subjectId: z.string().uuid().nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(versionedIdentifier).min(1).max(50),
    redactionProfile: z.string().min(2).max(80).regex(/^[a-z][a-z0-9-]*$/),
    maxFacts: z.number().int().min(1).max(500),
});
export const tasksAssistantContextFactSchema = z.strictObject({
    factType: z.enum(['tasks.task-summary', 'tasks.project-work-summary']),
    value: z.record(z.string().min(1).max(120), z.unknown()),
    sourceRevision: z.string().min(1).max(160),
    observedAt: z.string().datetime({ offset: true }),
    redactedFields: z.array(z.string().min(1).max(512)).max(100),
});
export const tasksAssistantContextResultSchema = z.strictObject({
    providerId: z.literal(tasksAssistantContextProviderId),
    providerModuleId: z.literal('tasks'),
    capability: z.literal(tasksAssistantContextCapability),
    facts: z.array(tasksAssistantContextFactSchema).max(1),
    unavailableReason: z.enum([
        'not-entitled',
        'not-enabled',
        'permission-denied',
        'provider-failed',
    ]).nullable(),
});
//# sourceMappingURL=tasks-assistant-context.contract.js.map